"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filterObject_1 = __importDefault(require("./filterObject"));
const useClients_1 = __importDefault(require("./useClients"));
const getClient_1 = __importDefault(require("./getClient"));
function useMutate() {
    const clients = useClients_1.default();
    return async (options) => {
        const finalVariables = filterObject_1.default({ ...options.variables }, '__typename');
        const client = getClient_1.default(clients, options.clientName);
        const result = await client.mutate({
            ...options,
            variables: finalVariables,
        });
        return result.data;
    };
}
exports.default = useMutate;
